import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/userDetails/dashboard';
import Users from './pages/userDetails/users';
import Products from './pages/master/products';
import PackagingIndex from './pages/packaging';
import PackagingSlip from './pages/packaging/packagin_slip';
import IssueNote from './pages/MaterialIssueNote/material-issue';
import MaterialIssueIndex from './pages/MaterialIssueNote';
import MaterialReturnIndex from './pages/MaterialReturnNote';
import ReturnNote from './pages/MaterialReturnNote/material-return';
import TestCertificateIndex from './pages/TestCertificate';
import TestCertificatePage from './pages/TestCertificate/TestCertificate';
import TestCertificateView from './pages/TestCertificate/TestCertificateView';


export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>

          {/* Public route */}
          <Route path="/login" element={<Login />} />

          {/* Protected tryal page */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Protected users page */}
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />

          {/* Protected users page */}
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />

          {/* Packaging Index page */}
          <Route
            path="/packagin-index"
            element={
              <ProtectedRoute>
                <PackagingIndex />
              </ProtectedRoute>
            }
          />

          {/* Packaging Slip (Create + View/Edit) */}
          <Route
            path="/packagin-slip/:id?"
            element={
              <ProtectedRoute>
                <PackagingSlip />
              </ProtectedRoute>
            }
          />

          {/* Material Issue Index */}
          <Route
            path="/material-issue-note/:id?"
            element={
              <ProtectedRoute>
                <IssueNote />
              </ProtectedRoute>
            }
          />

          {/* Material Issue Index */}
          <Route
            path="/material-issue-index"
            element={
              <ProtectedRoute>
                <MaterialIssueIndex />
              </ProtectedRoute>
            }
          />

          {/* Material Issue Index */}
          <Route
            path="/material-return-index"
            element={
              <ProtectedRoute>
                <MaterialReturnIndex />
              </ProtectedRoute>
            }
          />

          {/* Material Issue Index */}
          <Route
            path="/material-return-note/:id?"
            element={
              <ProtectedRoute>
                <ReturnNote />
              </ProtectedRoute>
            }
          />

          {/* Test Certificate Index */}
          <Route
            path="/test-certificate-index"
            element={
              <ProtectedRoute>
                <TestCertificateIndex />
              </ProtectedRoute>
            }
          />

          {/* Test Certificate Create */}
          <Route
            path="/test-certificate"
            element={
              <ProtectedRoute>
                <TestCertificatePage />
              </ProtectedRoute>
            }
          />

          {/* Test Certificate View */}
          <Route
            path="/test-certificate/:id"
            element={
              <ProtectedRoute>
                <TestCertificateView />
              </ProtectedRoute>
            }
          />

        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
